<template>
  <div id="progBar" class="progressbar">
    <div class="progressbar__wrapper">
      <div class="progressbar__nav">
        <BaseButton class="button-next" @click.native="skipBackward">
          <img
            class="arrow-left"
            alt="Previous"
            src="/images/training-menu/arrow-green.png"
          />
        </BaseButton>
      </div>
      <div v-if="!showStepSummary()" class="progressbar__wrapper">
        <div
          v-for="number in numQuestions"
          :key="number"
          :class="[
            'progressbar__circle',
            { 'progressbar__circle--active': number == currQuestion },
          ]"
        >
          {{ number }}
        </div>
      </div>
      <div v-else class="progressbar__wrapper">
        <div class="progressbar__circle mobile">
          {{ currQuestion }}
        </div>
        <div class="progressbar__circle mobile" style="width: 9px">
          /
        </div>
        <div class="progressbar__circle mobile">
          {{ numQuestions }}
        </div>
      </div>
      <div class="progressbar__nav">
        <BaseButton class="button-next" @click.native="skipForward">
          <img
            class="arrow-right"
            alt="Previous"
            src="/images/training-menu/arrow-green.png"
          />
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import BaseButton from '@/components/BaseButton/BaseButton.vue';
import Image from '@/components/Asset/Image.vue';
import EventBus from '@/utils/helpers/EventBus';

@Component({
  components: { Image, BaseButton },
})
export default class ActivityProgressSteps extends Vue {
  @Prop({ required: true })
  public isValid!: boolean;

  @Prop({ required: true })
  public numQuestions!: number;

  @Prop({ required: true })
  public currQuestion!: number;

  public isCircleShown = false;
  private switchedAtWidth = 0;

  private skipForward() {
    EventBus.$emit('activity-event-skip-forward');
  }

  private skipBackward() {
    EventBus.$emit('activity-event-skip-backward');
  }

  private showStepSummary() {
    // Always for mobile
    if (this.windowWidth < 768) return true;

    const progBarWidth =
      (document.getElementById('progBar')?.offsetWidth ?? 0) + 240;
    const windowWidth = this.windowWidth;

    if (progBarWidth > windowWidth) {
      this.switchedAtWidth = progBarWidth;
      return true;
    }
    if (windowWidth > this.switchedAtWidth) {
      this.switchedAtWidth = 0;
      return false;
    }

    return true;
  }

  public mounted() {
    this.showStepSummary();
  }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

$bottom-border-color: $grey200;
$bottom-bg-color: #f6f6f6;

$top-border-color: #f8ad18;
$top-bg-color: #f3e80e;

$circle-border-color-error: #e90c6e;
$circle-bg-color-error: #f696c0;

$circle-border-color-success: #00a251;
$circle-bg-color-success: #5bbb5a;

$circle-pimp-color: #f8f8f8;

.progressbar {
  position: fixed;

  height: 48px;
  bottom: 4px;
  left: 50%;

  transform: translateX(-60%);

  z-index: map.get($zindex, activityProgressBar);

  @media (max-width: #{$mobile}px) {
    bottom: 0px;
  }

  &__bottom,
  &__top {
    position: absolute;

    border-radius: 11px;
    height: 100%;
  }

  &__bottom {
    z-index: 1;
    width: 100%;

    border: 3.5px solid $bottom-border-color;
    background-color: $bottom-bg-color;
  }

  &__top {
    z-index: 2;

    border: 3.5px solid $top-border-color;
    background-color: $top-bg-color;

    transition: width 0.5s;

    &--inactive {
      border: 0;
    }
  }

  &__circle {
    position: relative;
    z-index: 2;
    top: -5px;
    width: 42px;
    height: 42px;
    line-height: 42px;
    border-radius: 50%;
    transition: 0.5s;
    background-color: transparent;
    font-size: 22px;
    font-weight: bold;
    color: $circle-bg-color-success;
    text-align: center;

    @media (max-width: #{$mobile}px) {
      top: 0px;
    }

    &--active {
      background-color: $circle-bg-color-success;
      font-size: 30px;
      color: white;
    }
  }

  &__wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
  }

  &__nav {
    position: relative;
    z-index: 2;
    top: -7px;
    width: 48px;
    height: 48px;
    @media (max-width: #{$mobile}px) {
      top: 0px;
    }
  }
}

.arrow-left {
  width: 30px;
  transform: rotate(90deg);
}

.arrow-right {
  width: 30px;
  transform: rotate(-90deg);
  margin-left: 18px;
}

.button-next {
  background: transparent;
  box-shadow: none;
  top: 15px;
  padding: 0;
}

.desktop-off {
  @media (min-width: #{$mobile}px) {
    display: none;
  }
}
</style>
